import type { StudyMissionSelectDto, StudySwimlaneSelectDto, StudyThreadSelectDto } from '@@types/api.types';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { type FC, useMemo } from 'react';
import { meiaRoute } from '../meia.constants';
import { MeiaPhaseAdvanceBar } from './meia-phase-advance-bar.component';
import { getMeiaMissionPhaseProgress } from './meia-phase-progress.util';

type MeiaP3AdvanceBarProps = {
  mission: StudyMissionSelectDto;
  studyId: string;
  swimlanes: StudySwimlaneSelectDto[];
  taskRows: Array<{ swimlaneId: string; threadId: string }>;
  threads: StudyThreadSelectDto[];
};

export const MeiaP3AdvanceBar: FC<MeiaP3AdvanceBarProps> = (props) => {
  const { mission, studyId, swimlanes, taskRows, threads } = props;

  const progress = useMemo(
    () =>
      getMeiaMissionPhaseProgress('p3', {
        isStudySignedOff: false,
        measureFlagsByMissionId: new Map(),
        mission,
        stages: swimlanes.map((swimlane) => ({ id: swimlane.id, threadId: swimlane.threadId })),
        taskRows,
        threadScoresByThreadId: new Map(),
        threads: threads.map((thread) => ({ id: thread.id, missionId: thread.missionId })),
      }),
    [mission, swimlanes, taskRows, threads],
  );

  return (
    <MeiaPhaseAdvanceBar
      backLink={{
        children: (
          <>
            <ArrowLeftIcon className="size-4" /> Back to Phase 2
          </>
        ),
        to: meiaRoute.studyTab({ query: { missionId: mission.id }, studyId, tab: 'p2' }),
      }}
      caption={
        <>
          {taskRows.length} {taskRows.length === 1 ? 'task' : 'tasks'} across {swimlanes.length}{' '}
          {swimlanes.length === 1 ? 'stage' : 'stages'} · Gate G3 needs every stage covered by at least one task
        </>
      }
      forwardLink={{
        children: (
          <>
            Advance to Phase 4 <ArrowRightIcon className="size-4" />
          </>
        ),
        to: meiaRoute.studyTab({ studyId, tab: 'p4' }),
      }}
      title={<>Phase 3 Progress: {progress}%</>}
    />
  );
};
